{
  "auth": {
    "onboarding": {
      "foreign": {
        "prompt": "اطلاعات پزشکی خود را وارد کنید.",
        "fullName": "نام و نام خانوادگی",
        "specialty": "تخصص",
        "specialtyPlaceholder": "مثلاً قلب و عروق",
        "specialtyChoose": "تخصص خود را انتخاب کنید",
        "specialtyGroupSpecialty": "تخصص‌ها",
        "specialtyGroupSubspecialty": "فوق‌تخصص‌ها",
        "specialtyOther": "سایر (در فهرست نیست)",
        "specialtyOtherLabel": "تخصص شما",
        "specialtyUnknown": "تخصص انتخاب‌شده در فهرست نیست. لطفاً دوباره انتخاب کنید.",
        "degree": "مدرک",
        "degreePlaceholder": "مثلاً MD یا MBChB",
        "country": "کشور صادرکنندهٔ پروانه",
        "countryPlaceholder": "انتخاب کشور",
        "city": "شهر",
        "license": "شمارهٔ پروانهٔ پزشکی (اختیاری)",
        "licenseHint": "شماره‌ای که کشور خودتان صادر کرده است.",
        "notice": "این اطلاعات بدون استعلام ثبت می‌شود و پروفایل شما با برچسب «تأییدنشده» نمایش داده خواهد شد.",
        "incomplete": "نام، تخصص، مدرک، کشور و شهر را کامل وارد کنید.",
        "licenseTaken": "این شمارهٔ پروانه قبلاً توسط حساب دیگری ثبت شده است.",
        "notAllowed": "این مسیر فقط برای شماره‌های غیرایرانی است. لطفاً کد نظام پزشکی خود را وارد کنید.",
        "unverified": "تأییدنشده"
      }
    }
  }
}
